module.exports = {
    methods: {
        /**
         * Is empty
         */
        exists(value) {
            if (value === undefined) {
                return false;
            }

            return true;
        },
    },
}